import { formattedDate } from '@shared/utils/helpers/date-formatter'

import { WebNotification } from '@protos/web_notification_pb'

export class WebNotificationNotificationData extends WebNotification {
  get formattedCreatedAt(): string {
    if (!this.createdAt) {
      return '-'
    }

    return formattedDate(this.createdAt)
  }
}
